<template>
  <div
    ref="slider"
    class="videos-slider swiper-container"
  >
    <div class="swiper-wrapper">
      <div
        class="video-slide swiper-slide"
        v-for="(video, index) in videos.list"
        :key="index"
      >
        <video-card
          :type-player="typePlayer"
          :display-vodalys="displayVodalys"
          :video="video"
        />
      </div>
    </div>
    <div class="videos-slider-navigation">
      <div
        ref="sliderBtnPrev"
        class="btn-prev"
      >
        <svg class="icon icon-medias-slider-arrow"><use xlink:href="#icon-medias-slider-arrow"></use></svg>
      </div>
      <div
        ref="sliderBtnNext"
        class="btn-next"
      >
        <svg class="icon icon-medias-slider-arrow"><use xlink:href="#icon-medias-slider-arrow"></use></svg>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper, { Navigation } from 'swiper';
import VideoCard from './VideoCard';

Swiper.use([Navigation]);

export default {
  components: {
    VideoCard,
  },
  props: {
    videos: {
      type: Object,
      required: true,
    },
    typePlayer: {
      type: String,
      required: true,
    },
    displayVodalys: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      slider: null,
      sliderOptions: {
        slidesPerView: 'auto',
        spaceBetween: 16,
        navigation: {
          nextEl: '.btn-next',
          prevEl: '.btn-prev',
        },
        breakpoints: {
          768: {
            spaceBetween: 32,
          },
        },
      },
    }
  },
  mounted() {
    this.createSlider();
    window.addEventListener('resize', this.slider.updateSize());
  },
  methods: {
    createSlider() {
      this.slider = new Swiper(this.$refs.slider, this.sliderOptions);
    },
  },
}
</script>
